import * as React from "react"

import { cn } from "@/lib/utils"

/* Shared field chrome — Input / Textarea / NativeSelect / SelectTrigger all use this. */
export const FIELD_CLASS =
  "w-full rounded-lg border border-input bg-surface text-base text-foreground placeholder:text-foreground-subtle " +
  "transition-[border-color,box-shadow,background-color] duration-fast " +
  "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20 " +
  "aria-[invalid=true]:border-danger aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-danger/20 " +
  "disabled:cursor-not-allowed disabled:bg-surface-subtle disabled:text-foreground-muted md:text-sm"

const Input = React.forwardRef(({ className, type, maxLength = 500, ...props }, ref) => {
  return (
    <input
      type={type}
      maxLength={maxLength}
      className={cn(
        FIELD_CLASS,
        "flex h-9 px-3 py-1 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
